import { createTheme, ThemeOptions } from "@mui/material";
import React from "react";
import { CheckBoxIcon } from "./components/shared/Checkbox/CheckBoxIcon";


declare module "@mui/material/Button" {
  interface ButtonPropsVariantOverrides {
    filter: true;
  }
}

export const svTheme = createTheme({
  palette: {
    primary: {
      main: '#111224',
    },
    secondary: {
      main: '#111224',
    },
    error: {
      main: '#de2117',
    },
    success: {
      main: '#42b346',
    },
  },
  typography: {
    h1: { fontFamily: "ubuntu", fontWeight: 600 },
    h2: { fontFamily: "ubuntu", fontWeight: 600 },
    h3: { fontFamily: "ubuntu", fontWeight: 600 },
    h4: { fontFamily: "ubuntu", fontWeight: 600 },
    h5: { fontFamily: "ubuntu", fontWeight: 600 },
    h6: { fontFamily: "ubuntu", fontWeight: 600 }
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '30px',
          padding: '5px 20px',
          textTransform: 'capitalize'
        }
      }
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          borderRadius: 5,
          height: "24px",
          width: "24px",
          backgroundColor: "#D9D9D9",
          boxShadow: "inset 0 0 0 1px rgb(207 207 207 / 20%), inset 0 -1px 0 rgb(181 181 181 / 10%)",
          boxSizing: "border-box", // <-- add this
          '&:hover': {
            backgroundColor: '#a3a3a3',
          },
          "&.Mui-disabled": {
            boxShadow: 'none',
            background: '#adadad',
          },
          "&.Mui-checked": {
            backgroundColor: "#111224",
            color: "#fff",
            "&:before": {
              display: "block",
              width: 24,
              height: 24
            },
            '&:hover': {
              backgroundColor: "#40078a"
            }
          }
        }
      },
      defaultProps: {
        icon: <></>,
        checkedIcon: <CheckBoxIcon />
      }
    },
    // MuiRadio: {
    //   styleOverrides: {
    //     root: {
    //       borderRadius: '50%',
    //       width: 16,
    //       height: 16,
    //       boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
    //       backgroundColor: '#f5f8fa',
    //       backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
    //       '&.Mui-focusVisible': {
    //         outline: '2px auto rgba(19,124,189,.6)',
    //         outlineOffset: 2,
    //       },
    //       '&:hover': {
    //         backgroundColor: '#ebf1f5',
    //       },
    //       "&.Mui-disabled": {
    //         boxShadow: 'none',
    //         background: 'rgba(206,217,224,.5)',
    //       },
    //       "&.Mui-checked": {
    //         backgroundColor: "#460303",
    //         "&:before": {
    //           display: "block",
    //           width: 16,
    //           height: 16,
    //           backgroundImage: 'radial-gradient(#fff,#fff 28%,transparent 32%)',
    //           content: '""',
    //         }
    //       }
    //     }
    //   }
    // }
  }

});
